import { HttpParams } from '@angular/common/http';
import { environment } from './environments/environment';

export const api = environment.api;

export interface BaseFilter {
  limit?: number;
  skip?: number;
  sortField?: string;
  sortOrder?: string;
  query?: string;
  pricingGroupIds?: string;
  active?: boolean;
}

export interface HistoryFilter extends BaseFilter {
  customerIds?: string;
  statuses?: string;
  /** Comma-separated rep ids; Territory Managers only (the API ignores it for everyone else). */
  repIds?: string;
  startDate?: string;
  endDate?: string;
  skip?: number;
  limit?: number;
}

export interface ServiceSlipFilter extends BaseFilter {
  types?: string;
  customerIds?: string;
  repIds?: string;
  startDate?: string;
  endDate?: string;
}

export interface PaginatedResult<T> {
  data: T[];
  total: number;
}

const removeEmpty = (obj: BaseFilter): BaseFilter => {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? removeEmpty(v) : v }), {});
};

export class HttpClientUtils {
  static toHttpParams(obj: BaseFilter): HttpParams {
    const clearedParams = removeEmpty(obj);

    return new HttpParams().appendAll({ ...clearedParams });
  }
}
